import {
  EmailValidation,
  EmailValidationPayload,
  SocialLoginPayload,
  SocialLogin,
  PackageInfo,
} from './interfaces';
import { usePost, useFetch } from '@selfserve/react-hooks';

import { apiEndpoints } from '@selfserve/react-utils';

export const useEmailValidationRequest = () =>
  usePost<EmailValidationPayload, EmailValidation>(
    apiEndpoints.emailValidation
  );

export const useSocialLoginRequest = () =>
  usePost<SocialLoginPayload, SocialLogin>(apiEndpoints.socialLogin);

export const usePackageInfoRequest = (desiredPackageId: string) => {
  const url = apiEndpoints.packageInfo.replace(':id', desiredPackageId);

  return useFetch<PackageInfo>(url, undefined, {
    enabled: !!url,
  });
};

export * from './interfaces';
export * from './schemas';
